module.exports = __webpack_public_path__ + "img/危品WCA_01.f98d41b4.png";